import React from "react";
import { ProductsData } from "./data";

const Product = ({ title, description, items }: ProductsData) => {
  return (
    <div className="flex-1 py-4 sm:py-6 px-4 bg-gray-200">
      <span className="font-bold text-xl">{title}</span>
      <br />
      {description && <span>{description}</span>}
      <ul className="ml-6 mt-2 list-disc">
        {items.map((item, index) => (
          <li key={`pil-${index}`}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default Product;
